import { render, staticRenderFns } from "./ConsultServicePointPage.vue?vue&type=template&id=55fd1b3a"
import script from "./ConsultServicePointPage.vue?vue&type=script&lang=ts"
export * from "./ConsultServicePointPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultServicePointPage.vue?vue&type=style&index=0&id=55fd1b3a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports